import type { JsonSchema } from '../helpers/helper.schema-format'

// Hand-maintained: mirrors the StakeholderInfo shape returned by getStakeholderInfo, plus the
// contactPerson attached by mapStakeholdersPartial. Drives formatBySchema so every field gets a
// default, like the contract-state schema does for the commerce partial. Only declared properties
// reach documents. Not generated by make types — keep in sync manually.

const address: JsonSchema = {
  type: 'object',
  properties: {
    streetName: { type: 'string' },
    streetNumber: { type: 'string' },
    postalCode: { type: 'string' },
    postalPlace: { type: 'string' },
    country: { type: 'string' },
    countryCode: { type: 'string' },
  },
}

const contactInfo: JsonSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' },
    phone: { type: 'string' },
    address,
  },
}

const contactPerson: JsonSchema = {
  type: 'object',
  properties: {
    name: { type: 'string' },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    email: { type: 'string' },
    phone: { type: 'string' },
    address,
  },
}

const stakeholderInfo: JsonSchema = {
  type: 'object',
  properties: {
    type: { type: 'string' },
    partyId: { type: 'string' },
    name: { type: 'string' },
    firstName: { type: 'string' },
    lastName: { type: 'string' },
    email: { type: 'string' },
    phone: { type: 'string' },
    orgNumber: { type: 'string' },
    isFrozen: { type: 'boolean' },
    address,
    contactInfo: {
      type: 'object',
      properties: {
        billing: contactInfo,
        shipping: contactInfo,
        other: contactInfo,
      },
    },
    contactPerson,
    signer: contactPerson,
  },
}

export const stakeholdersSchema: JsonSchema = {
  type: 'object',
  properties: {
    vendor: stakeholderInfo,
    customer: stakeholderInfo,
    driver: stakeholderInfo,
    suppliers: { type: 'array', items: stakeholderInfo },
    vehicleSupplier: stakeholderInfo,
  },
}
